export const APP_VERSION = '1.0.0';

export const APP_NAME = 'Ferty9 Health Platform';

export const APP_PLATFORM_NAME = 'Ferty9 Health Platform';

export const APP_DESCRIPTION =
  'Secure connected-care platform for clinical insights, patient experience, operational reporting, and business intelligence.';

export const APP_DEVELOPED_BY = 'Ferty9 IT Department';

export const APP_DEVELOPED_FOR = 'Ferty9 Fertility Center';

export const APP_MANAGED_BY = 'Ferty9 IT Department';

export const APP_RELEASE_CHANNEL = 'enterprise';

export const APP_COPYRIGHT_NOTICE = 'Copyright (c) Ferty9. All rights reserved.';

export const APP_PROPRIETARY_NOTICE =
  'This software and associated documentation are proprietary and confidential. Unauthorized copying, modification, distribution, deployment, or use is prohibited without written permission.';

export const APP_VERSION_INFO = {
  name: APP_NAME,
  platform: APP_PLATFORM_NAME,
  description: APP_DESCRIPTION,
  version: APP_VERSION,
  releaseChannel: APP_RELEASE_CHANNEL,
  developedBy: APP_DEVELOPED_BY,
  developedFor: APP_DEVELOPED_FOR,
  managedBy: APP_MANAGED_BY,
  copyrightNotice: APP_COPYRIGHT_NOTICE,
  proprietaryNotice: APP_PROPRIETARY_NOTICE,
} as const;
